module.exports = __webpack_public_path__ + "img/six-page-bg-km.2dc30c06.png";